import "@/index.css";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import ScanPage from "@/pages/ScanPage";
import ReportPage from "@/pages/ReportPage";
import MonitorPage from "@/pages/MonitorPage";
import PrivacyPage from "@/pages/PrivacyPage";
import CWSScreenshots from "@/pages/CWSScreenshots";
import PricingPage from "@/pages/PricingPage";
import BillingSuccessPage from "@/pages/BillingSuccessPage";
import LeaderboardPage from "@/pages/LeaderboardPage";
import VerifyPage from "@/pages/verify/VerifyPage";
import RefundPage from "@/pages/RefundPage";
import AgentsPage from "@/pages/AgentsPage";
import DetectionPage from "@/pages/DetectionPage";
import ApiDocsPage from "@/pages/ApiDocsPage";
import OrgsPage from "@/pages/OrgsPage";
import StackDeployPage from "@/pages/StackDeployPage";
import GovernancePage from "@/pages/GovernancePage";
import AIDoctorPage from "@/pages/AIDoctorPage";
import AIDebtPage from "@/pages/AIDebtPage";
import DocsPage from "@/pages/DocsPage";

function App() {
  return (
    <HelmetProvider>
    <div className="min-h-screen bg-white">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/scan/:scanId" element={<ScanPage />} />
          <Route path="/r/:reportId" element={<ReportPage />} />
          <Route path="/monitor" element={<MonitorPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/cws-screenshots" element={<CWSScreenshots />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/billing/success" element={<BillingSuccessPage />} />
          <Route path="/leaderboard/ai-bots" element={<LeaderboardPage />} />
          <Route path="/verify" element={<VerifyPage />} />
          <Route path="/refund" element={<RefundPage />} />
          <Route path="/agents" element={<AgentsPage />} />
          <Route path="/agents/detection" element={<DetectionPage />} />
          <Route path="/docs/api" element={<ApiDocsPage />} />
          <Route path="/agents/stack-deploy" element={<StackDeployPage />} />
          <Route path="/agents/governance" element={<GovernancePage />} />
          <Route path="/agents/ai-doctor" element={<AIDoctorPage />} />
          <Route path="/agents/ai-debt" element={<AIDebtPage />} />
          <Route path="/docs" element={<DocsPage />} />
          <Route path="/orgs" element={<OrgsPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </div>
    </HelmetProvider>
  );
}

export default App;
